const germanNumbers = {
  units: ['null', 'ein', 'zwei', 'drei', 'vier', 'fünf', 'sechs', 'sieben', 'acht', 'neun'],
  teens: ['zehn', 'elf', 'zwölf', 'dreizehn', 'vierzehn', 'fünfzehn', 'sechzehn', 'siebzehn', 'achtzehn', 'neunzehn'],
  tens: ['', 'zehn', 'zwanzig', 'dreißig', 'vierzig', 'fünfzig', 'sechzig', 'siebzig', 'achtzig', 'neunzig']
};

function numberToGermanWords(num) {
  if (num === 0) return 'null';
  if (num < 10) return germanNumbers.units[num];
  if (num < 20) return germanNumbers.teens[num - 10];
  if (num < 100) {
    const t = Math.floor(num / 10);
    const u = num % 10;
    return u === 0 ? germanNumbers.tens[t] : germanNumbers.units[u] + 'und' + germanNumbers.tens[t];
  }
  if (num < 1000) {
    const h = Math.floor(num / 100);
    const r = num % 100;
    return (h === 1 ? 'ein' : germanNumbers.units[h]) + 'hundert' + (r === 0 ? '' : numberToGermanWords(r));
  }
  if (num < 1000000) {
    const th = Math.floor(num / 1000);
    const r = num % 1000;
    return (th === 1 ? 'ein' : numberToGermanWords(th)) + 'tausend' + (r === 0 ? '' : numberToGermanWords(r));
  }
  return num.toString(); // Fallback for very large numbers
}

export const convertToGerman = (num) => {
  const isNegative = num < 0;
  num = Math.abs(num);
  const intPart = Math.floor(num);
  const decPart = Math.round((num - intPart) * 100);
  
  let res = (isNegative ? 'minus ' : '') + numberToGermanWords(intPart);
  if (decPart > 0) res += ' Komma ' + numberToGermanWords(decPart);
  return res;
};